(function() {
    if (window.__mfAdImageSwapInit) return;
    window.__mfAdImageSwapInit = true;

    const ADID_COOKIE = "ad_id";

    const adIdToClass = {
        "from_mf_eid": ["120239605976150244", "120239553432750244"],
        "from_mf_shaadi": ["120239608445230244"],
    };

    function setCookie(name, value, minutes) {
        const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
        document.cookie = `${name}=${value}; expires=${expires}; path=/`;
    }

    function getCookie(name) {
        return document.cookie
            .split('; ')
            .find((row) => row.startsWith(name + '='))
            ?.split('=')[1];
    }

    function getAdId() {
        const params = new URLSearchParams(location.search);
        const cookie = getCookie(ADID_COOKIE)
        return {
            adId: params.get("ad_id") || cookie,
            cookie,
        };
    }

    function showImg(img) {
        if (!img) return;
        img.classList.remove("hidden");
        img.removeAttribute("aria-hidden");
    }

    function applySwap(root) {
        const {adId, cookie} = getAdId();
        if (!adId) return;

        if(adId != cookie){
            setCookie(ADID_COOKIE, adId, 10080); // 7 days
        }

        const targetClass = Object.keys(adIdToClass).find(key => adIdToClass[key].includes(adId)) || null;
        if (!targetClass) return;

        const cards = (root || document).querySelectorAll(
            ".card-product.media.media--transparent"
        );
        if (!cards.length) return;

        cards.forEach((card) => {
            if (card.dataset.mfAdSwapApplied === targetClass) return;

            const normal = card.querySelector("img.from_media");
            const eid = card.querySelector("img.from_mf_eid");
            const shaadi = card.querySelector("img.from_mf_shaadi");

            const target = card.querySelector(`.${targetClass}`);
            if (!target) return;

            [normal, eid, shaadi].forEach(img => {
                if (!img) return;
                if (!img.classList.contains(targetClass)) {
                    img.remove();
                }
            });
            showImg(target);

            card.dataset.mfAdSwapApplied = targetClass;
        });
    }

    function findGridContainer() {
        return (
            document.querySelector("#ProductGridContainer") ||
            document.querySelector(".product-grid") ||
            document.querySelector("[data-product-grid]") ||
            document.querySelector("main") ||
            document.body
        );
    }

    function installObserver() {
        const container = findGridContainer();

        const obs = new MutationObserver((mutations) => {
            for (const m of mutations) {
                for (const node of m.addedNodes) {
                    if (!(node instanceof Element)) continue;

                    if (
                        node.matches?.(".card-product.media.media--transparent") ||
                        node.querySelector?.(".card-product.media.media--transparent")
                    ) {
                        applySwap(node);
                    }
                }
            }
        });

        obs.observe(container, {
            childList: true,
            subtree: true
        });

        document.addEventListener("shopify:section:load", (e) => applySwap(e.target));

        window.addEventListener("pageshow", () => applySwap(document));
    }

    function init() {
        applySwap(document);
        installObserver();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();